import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { Eye, ShieldCheck } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ConfidentialityUnlock = ({ email, name, source }) => {
  const navigate = useNavigate();
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');

  const handleUnlock = () => {
    if (!agreed) {
      setError('Please tick the box to confirm before viewing the backlog.');
      return;
    }
    fetch(`${BACKEND_URL}/api/confidentiality-ack`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, name: name || '', source: source || '' }),
    }).catch(() => {});
    localStorage.setItem('resiax_access', 'granted');
    navigate('/features');
  };

  return (
    <div data-testid="confidentiality-unlock" className="bg-[#FFF8F5] border border-[#B5541B]/20 rounded-xl p-5 text-left max-w-md mx-auto space-y-4">
      <div className="flex items-center gap-2 text-[#B5541B] font-semibold text-sm">
        <ShieldCheck className="w-4 h-4" />
        Want to see what we&apos;re building?
      </div>
      <div className="flex items-start gap-3">
        <Checkbox
          id="confidentiality-agree"
          data-testid="confidentiality-agree-checkbox"
          checked={agreed}
          onCheckedChange={(v) => { setAgreed(!!v); setError(''); }}
          className="mt-0.5 data-[state=checked]:bg-[#B5541B] data-[state=checked]:border-[#B5541B]"
        />
        <Label htmlFor="confidentiality-agree" className="text-xs text-[#3B3535]/80 leading-relaxed cursor-pointer">
          I understand the ResiAX feature backlog and roadmap are commercially confidential and
          remain the property of Teqie Ltd. By viewing them I agree to keep their contents
          confidential and not to share, copy or use them other than to evaluate ResiAX.
        </Label>
      </div>
      {error && <p data-testid="confidentiality-error" className="text-xs text-red-600">{error}</p>}
      <Button
        data-testid="confidentiality-unlock-btn"
        onClick={handleUnlock}
        className="bg-[#1F1E1E] hover:bg-[#2D2A2A] text-white font-semibold h-auto px-6 py-3 rounded-full w-full"
      >
        <Eye className="mr-2 w-4 h-4" />
        Agree &amp; view the feature backlog
      </Button>
    </div>
  );
};

export default ConfidentialityUnlock;
